import { FeatureToggle, FeatureToggleValues } from '../types/FeatureToggles';

export const defaultFeatureToggles: FeatureToggleValues = {
  [FeatureToggle.OrderModalAuthMode]: false,
  [FeatureToggle.hardcodeNoindexNofollow]: false,
  [FeatureToggle.redeemDelayWarning]: false,
  [FeatureToggle.languageSwitcher]: false,
  [FeatureToggle.applePay]: false,
  [FeatureToggle.isPhysicalOrderDescriptionOnThankYouPages]: false,
  [FeatureToggle.isDigitalWrappersAndPersonalNoteEnabled]: false,
  [FeatureToggle.isRedeemLanguageSwitcher]: false,
  [FeatureToggle.isShipmentMethodsEnabled]: false,
  [FeatureToggle.adyenCreditCard]: false,
  [FeatureToggle.promoPopup]: false,
  [FeatureToggle.isCBBEFrench]: false,
  [FeatureToggle.isFeaturedCards]: false,
  [FeatureToggle.isFooterLogos]: false,
  [FeatureToggle.isSearchV1]: false,
  [FeatureToggle.isAnchorLink]: false,
  [FeatureToggle.isSearchDataLayer]: false,
  [FeatureToggle.isOrderParam]: false,
  [FeatureToggle.isSeoBlocksCollapse]: false,
  [FeatureToggle.isDeliveryQuantity]: false,
  [FeatureToggle.isPersonalNotePlaceholder]: false,
  [FeatureToggle.isCOPFilter]: false,
  [FeatureToggle.isAdyenPayPal]: false,
  [FeatureToggle.isErrorMessages]: false,
  [FeatureToggle.isHandV1]: false,
  [FeatureToggle.isNoPublishDate]: false,
  [FeatureToggle.isLocalizePaymentMethodDescription]: false,
  [FeatureToggle.isNewPaymentLogos]: false,
  [FeatureToggle.isRedeemUnusedCardsOn]: false,
  [FeatureToggle.isPayPalEmailWarning]: false,
  [FeatureToggle.isBusinessPageV3]: false,
  [FeatureToggle.isHiddenPhysicalDeliveryDate]: false,
  [FeatureToggle.isNewVariationsView]: false,
  [FeatureToggle.isActivationPageContentFromCBE]: false,
  [FeatureToggle.isContactPageDynamically]: false,
  [FeatureToggle.isAdyenApplePay]: false,
  [FeatureToggle.isPDPButtonV1]: false,
  [FeatureToggle.isPDPBusinessModalUsps]: false,
  [FeatureToggle.isGoogleRecaptchaBadgeHidden]: false,
  [FeatureToggle.isNavigationIconTextOn]: false,
  [FeatureToggle.isGCSOrangeColor]: false,
  [FeatureToggle.isBiggerProductImageOnMobile]: false,
  [FeatureToggle.isDeliveryInformationAdditionalFieldOn]: false,
  [FeatureToggle.isCheckOutButtonV2On]: false,
  [FeatureToggle.isVariationsOnFlyOn]: false,
  [FeatureToggle.isRedeemBrandLogosOn]: false,
  [FeatureToggle.isRedeemFAQAndSEOSectionsOn]: false,
  [FeatureToggle.isRedeemHeaderVideoOn]: false,
  [FeatureToggle.isPDPVariationsOnFlyOn]: false,
  [FeatureToggle.isRedeemSpecificDoublerModalOn]: false,
  [FeatureToggle.isAdyenBlikOn]: false,
  [FeatureToggle.isAdyenPrzelewyOn]: false,
  [FeatureToggle.isEmblaSliderOn]: false,
  [FeatureToggle.isPaymentIconsFromCBEOn]: false,
  [FeatureToggle.isCollectBillingInfoOn]: false,
  [FeatureToggle.isLangSwitcherFixOn]: false,
  [FeatureToggle.isOrganizationStructuredDataOn]: false,
  [FeatureToggle.isGooglePayOn]: false,
  [FeatureToggle.isLogosFromCBEOn]: false,
  [FeatureToggle.isCookiesFooterLinkOn]: false,
  [FeatureToggle.isAdyenTrustlyOn]: false,
  [FeatureToggle.isLandingPageV2On]: false,
};

export const FEATURE_TOGGLES_LOCAL_STORAGE_ID = 'featureTogglesId';
export const FEATURE_TOGGLES_QUERY_PARAM = 'ftid';
export const FEATURE_TOGGLES_ENVIRONMENT_FOLDER = `cadeaubon/${CONFIG.storyblokEnvironmentFolder}`;
export const FEATURE_TOGGLES_PACKAGE_FOLDER = 'feature-toggles';
export const FEATURE_TOGGLES_TOKEN = 'bbr6S8iPmBmrHADh2ySbEQtt';
